import { red } from '@mui/material/colors';
import { createTheme } from '@mui/material/styles';

// A custom theme for this app
const theme = createTheme({
  palette: {
    primary: {
      main: '#154734',
    },
    secondary: {
      main: '#19857b',
    },
    error: {
      main: red.A400,
    },
  },

  components: {
    MuiButton: {
      defaultProps: {
        size: "small",
        variant: "contained",
        color: "primary",
      },
      variants: [
        {
          props: { variant: 'light' },
          style: {
            textTransform: "none", 
            //marginTop: "0.5em !important",
            //height: "2em",
            color: "#556cd6", 
            backgroundColor: "rgba(85, 108, 214, 0.08)", 
            border: "1pt solid #556cd6",
          },
        },
      ]
    },
    MuiCheckbox: {
      defaultProps: {
        size: "small"
      }
    },
    MuiToggleButtonGroup: {
      defaultProps: {
        size: "small",
        color: "primary",
      },
    },
  }
});

export default theme;
